import UtilityMixin from "../../utility/UtilityMixin";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [UtilityMixin],
	data() {
		return {
			search: "",
			openPrestazioni: [], // Array per gestire l'espansione delle singole prestazioni
			mappaColori: {
				"IP (Infermiere)": "#3498db",
				"FISIO (Fisioterapista)": "#2ecc71",
				OSS: "#e67e22",
				"PSIC (Psicologo)": "#9b59b6",
				"MED (Medico)": "#e74c3c",
			},
			pratiche: [],
			siatLetturaPianiSceltaPathResource: "/siat/letturapianiscelta",
			siatLetturaPianiAssegnatiPathResource: "/siat/letturapiani",
			siatConfermaLetturaPathResource: "/siat/confermalettura",
			eventoSelezionato: null,
		};
	},
	methods: {
		siatLoadLetturaPianiScelta() {
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(this.siatLetturaPianiSceltaPathResource, {}, this.siatLoadLetturaPianiSceltaSuccess, this.siatLoadLetturaPianiSceltaError);
		},
		siatLoadLetturaPianiSceltaSuccess(response) {
			this.pratiche = response.data.data ? response.data.data : [];
			console.log(this.pratiche);
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiSceltaError() {
			console.error("Errore nel caricamento dei dati per storico stati setting");
			this.closeShowModalLoading();
		},
		siatConfermaLettura(evento) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			UtilityMixin.methods.putResource(this.siatConfermaLetturaPathResource + "/" + evento.id, {}, this.siatConfermaLetturaSuccess, this.siatConfermaLetturaError);
		},
		siatConfermaLetturaSuccess(response) {
			console.log(response);
			this.closeShowModalLoading();
		},
		siatConfermaLetturaError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiAssegnati() {
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(this.siatLetturaPianiAssegnatiPathResource, {}, this.siatLoadLetturaPianiAssegnatiSuccess, this.siatLoadLetturaPianiAssegnatiError);
		},
		siatLoadLetturaPianiAssegnatiSuccess(response) {
			this.pratiche = response.data.data ? response.data.data : [];
			console.log(this.pratiche);
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiAssegnatiError() {
			console.error("Errore nel caricamento dei dati per storico stati setting");
			this.closeShowModalLoading();
		},
	},
};
